import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MeetingAttendanceReport,
  OnlineMeeting,
} from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TeamsMeetingService {
  private apiUrl = environment.apiUrl + '/teamsmeeting';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Holt ein Teams Meeting anhand der Meeting-ID.
   * @param meetingId Die ID des Meetings.
   * @returns OnlineMeeting Observable mit dem Teams Meeting.
   */
  get(meetingId: string): Observable<OnlineMeeting> {
    return this.httpClient.get<OnlineMeeting>(
      `${this.apiUrl}/${encodeURIComponent(meetingId)}`,
    );
  }

  /**
   * Holt die Sitzungen eines Teams Meetings anhand der Meeting-ID.
   * @param meetingId Die ID des Meetings.
   * @returns MeetingAttendanceReport[] Observable mit einer Liste der Sitzungen.
   */
  getAttendanceReports(
    meetingId: string,
  ): Observable<MeetingAttendanceReport[]> {
    return this.httpClient.get<MeetingAttendanceReport[]>(
      `${this.apiUrl}/${encodeURIComponent(meetingId)}/attendanceReports`,
    );
  }
}
